
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/commerce-ai",
      function () {
        return require("private-next-pages/commerce-ai.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/commerce-ai"])
      });
    }
  